// extracted by mini-css-extract-plugin
export var cardContainer = "_ow-0";
export var cardHeader = "_ow-2";
export var collapsedState = "_ow-3";
export var dragHandle = "_ow-5";
export var dragHandleIcon = "_ow-6";
export var dragging = "_ow-1";
export var titleArea = "_ow-4";